import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SharedDataService } from 'src/app/services/app/shared-service/shared-data.service';
import { SupportService } from 'src/app/services/core/support/support.service';
import { sweetAlert } from 'src/app/utils/swal';
import {
  applyTicketUpdate,
  isBrokerStaff,
  prepareTicket,
  SUPPORT_ROLE_LABELS,
  SUPPORT_TRIP_SOURCES,
  TICKET_PRIORITY_OPTIONS,
  TICKET_STATUS_OPTIONS,
  TicketStatus
} from 'src/app/utils/support.utils';
@UntilDestroy()

@Component({
  selector: 'app-ticket-detail',
  templateUrl: './ticket-detail.component.html',
  styleUrls: ['./ticket-detail.component.css']
})
export class TicketDetailComponent implements OnInit {
  ticketId: any;
  ticket: any;
  currentUser: any;
  isBrokerStaff = false;
  tripId: any;
  tripSource: any;
  selectedReference: any;
  statusOptions = TICKET_STATUS_OPTIONS;
  priorityOptions = TICKET_PRIORITY_OPTIONS;
  roleLabels = SUPPORT_ROLE_LABELS;
  ticketStatus = TicketStatus;
  isEditing = false;
  editForm = { subject: '', description: '' };

  constructor(
    private route: ActivatedRoute,
    private supportService: SupportService,
    private sharedDataService: SharedDataService
  ) { }

  ngOnInit() {
    this.ticketId = this.route.snapshot.params['id'];
    this.getUser();
    this.getTicket();
    this.listenTicketUpdates();
  }

  getUser() {
    this.sharedDataService.getUser().pipe(untilDestroyed(this)).subscribe((user) => {
      this.currentUser = user;
      this.isBrokerStaff = isBrokerStaff(user);
    });
  }

  getTicket() {
    this.supportService.getTicket(this.ticketId).pipe(untilDestroyed(this)).subscribe((data: any) => {
      this.ticket = prepareTicket(data);
    }, (err) => {
      sweetAlert('Error', err, 'error', 'OK');
    });
  }

  // applied in place, fetching the ticket again would move it out of pending
  listenTicketUpdates() {
    this.supportService.ticketUpdated$.pipe(untilDestroyed(this)).subscribe((data: any) => {
      if (this.ticket && data.ticketId === this.ticketId) {
        applyTicketUpdate(this.ticket, data);
      }
    });
  }

  updateTicket(payload: any) {
    this.supportService.updateTicket(this.ticketId, payload).pipe(untilDestroyed(this)).subscribe((data: any) => {
      this.ticket = prepareTicket(data);
      this.isEditing = false;
    }, (err) => {
      sweetAlert('Error', err, 'error', 'OK');
    });
  }

  get canEdit() {
    return this.ticket.createdBy?.id === this.currentUser?.id && this.ticket.status !== TicketStatus.CLOSED;
  }

  startEdit() {
    this.editForm = { subject: this.ticket.subject, description: this.ticket.description };
    this.isEditing = true;
  }

  saveEdit() {
    const subject = this.editForm.subject.trim();
    if (!subject) {
      return;
    }
    this.updateTicket({ subject, description: this.editForm.description });
  }

  closeTicket() {
    this.updateTicket({ status: TicketStatus.CLOSED });
  }

  // a trip or a bill opens the trip details, anything else the reference details
  openReference() {
    this.tripSource = SUPPORT_TRIP_SOURCES[this.ticket.reference.type];
    if (this.tripSource) {
      this.tripId = this.ticket.reference.id;
    } else {
      this.selectedReference = this.ticket.reference;
    }
  }
}
